import { useState, useContext, useEffect } from "react";
import { Form, Tooltip, Modal, FormSelect } from "react-bootstrap";
import axios from "axios";
import { AuthContext } from "../../../../contexts/AuthContext";
import "./DetalheAuditoria.css";
import { Link, useNavigate, useLocation, useParams } from "react-router-dom";
import * as links from "../../../../utils/links";
import moment from "moment";
import { Input, Button, Row } from "antd";
import checkImage from "../../../../assets/images/image_check.png";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import LoadingAction from "../../../../themes/LoadingAction/LoadingAction";

export default function DetalheAuditoria() {

  const location = useLocation();
  const clienteInfo = location.state;

  const { setDataUser, authInfo, setNotiMessage } = useContext(AuthContext);
  const { dataUser } = authInfo;
  const [isLoading, setIsLoading] = useState(true);
  const [pagamentos, setPagamentos] = useState([])

  let navigate = useNavigate();
  const token = authInfo?.dataUser?.token;
  const [pagamento, setPagamento] = useState({})
  const [hasPrinted, setHasPrinted] = useState(false);

  const { id } = useParams();

  useEffect(() => {
    buscaPagamento()
  }, []);

  useEffect(() => {
    const shouldAutoPrint = new URLSearchParams(location.search).get("print") === "1";
    if (!shouldAutoPrint) return;
    if (!pagamento?.pagamento) return;
    if (hasPrinted) return;

    setHasPrinted(true);
    const closeAfterPrint = () => {
      if (window.opener) window.close();
    };

    window.addEventListener("afterprint", closeAfterPrint);
    const t = setTimeout(() => {
      try {
        window.focus();
        window.print();
      } catch (_) {}
    }, 250);

    return () => {
      clearTimeout(t);
      window.removeEventListener("afterprint", closeAfterPrint);
    };
  }, [location.search, pagamento, hasPrinted]);

  function buscaPagamento() {
    setIsLoading(true)
    axios.get(
      `${process.env.REACT_APP_SERVIDOR}/auditoria-pagamentos-detalhe/${id}`, {
      headers: {
        "x-access-token": token,
        "content-type": "application/json",
      },
    }
    ).then((res) => {
      setIsLoading(false)
      console.log(res)
      setPagamento(res.data)
    }).catch((err) => {
      setIsLoading(false);
      setNotiMessage({
        type: "error",
        message: err.response?.data?.error
          ? err.response?.data?.error
          : `A sua sessão expirou, para continuar faça login novamente.`,
      });
    });
  }

  const formatCurrency = (value) =>
    new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(Number(value));



  return (
    <div class="container mw-100">
      {isLoading && <LoadingAction />}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1 className="h4 fw-bold">Detalhe de Auditoria: {clienteInfo?.nome}</h1>
        <div className="d-flex col-8 col-md-auto mb-2">
          <button className="custom-btn btn btn-outline-secondary"
            onClick={() =>
              navigate(`${links.AUDITORIA}/${id}`, {
                state: clienteInfo,
              })
            }>VOLTAR</button>
        </div>
      </div>

      {/* Tabela */}
      {pagamento.pagamento ?
        <div className="card" style={{ border: '1px solid rgba(0, 0, 0, 0.1)', borderRadius: '8px' }}>
          <div className="card-header">
            <h5>Relatório Detalhado do Pagamento</h5>
          </div>
          <div className="card-body row">
            <div className="col-12 col-lg-12 mb-2">
              <h5>Informações da Máquina</h5>
            </div>
            <div className="col-3 col-lg-2 mb-2">
              <label>Máquina</label>
              <p>{pagamento.pagamento.maquina.nome}</p>
            </div>
            <div className="col-3 col-lg-2 mb-2">
              <label>Descrição</label>
              <p>{pagamento.pagamento.maquina.descricao}</p>
            </div>
          </div>
          <div className="card-body row">
            <div className="col-12 col-lg-12 mb-2">
              <h5>Informações da Transação</h5>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Data</label>
              <p>{moment(pagamento.pagamento.data).format('DD/MM/YYYY HH:mm')}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Estornado?</label>
              <p>{pagamento.pagamento.estornado ? 'Sim' : 'Não'}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Tipo de Pagamento</label>
              <p>{pagamento.pagamento.tipo === "bank_transfer" ? 'PIX' : pagamento.pagamento.tipo === "credit_card" ? 'Cartão de Crédito' : pagamento.pagamento.tipo === "debit_card" ? 'Cartão de Débito' : 'Dinheiro'}</p>
            </div>
            {pagamento.pagamento.tipo === 'credit_card' || pagamento.pagamento.tipo === 'debit_card' ?
              <div className="col-3 col-lg-1 mb-2">
                <label> Número Cartão</label>
                <p>*** {pagamento.mercadopago.card.last_four_digits}</p>
              </div>
              :
              null}
            <div className="col-3 col-lg-1 mb-2">
              <label>Valor</label>
              <p>{formatCurrency(pagamento.pagamento.valor)}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Taxas</label>
              <p>{formatCurrency(pagamento.pagamento.taxas)}</p>
            </div>
          </div>
          <div className="card-body row">
            <div className="col-12 col-lg-12 mb-2">
              <h5>Informações da Transação Bancária</h5>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Id da Transação</label>
              <p>{pagamento.mercadopago.id}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Modo Binário</label>
              <p>{pagamento.mercadopago.binary_mode ? 'Sim' : 'Não'}</p>
            </div>
            <div className="col-3 col-lg-2 mb-2">
              <label>ID de Execução de Encargos</label>
              <p>{pagamento.mercadopago.charges_execution_info.internal_execution.execution_id}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>ID do Coletor</label>
              <p>{pagamento.mercadopago.collector_id}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Moeda</label>
              <p>{pagamento.mercadopago.currency_id}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Data da Criação</label>
              <p>{moment(pagamento.mercadopago.date_created).format('DD/MM/YYYY - HH:mm')}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Data da Aprovação</label>
              <p>{moment(pagamento.mercadopago.date_approved).format('DD/MM/YYYY - HH:mm')}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Última Atualização</label>
              <p>{moment(pagamento.mercadopago.date_last_updated).format('DD/MM/YYYY - HH:mm')}</p>
            </div>
            <div className="col-3 col-lg-3 mb-2">
              <label>Descrição da Transação</label>
              <p>{pagamento.mercadopago.description}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>ID do Emitente</label>
              <p>{pagamento.mercadopago.issuer_id}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Live Mode?</label>
              <p>{pagamento.mercadopago.live_mode ? 'Sim' : 'Não'}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Liber. do Dinheiro</label>
              <p>{moment(pagamento.mercadopago.money_release_date).format('DD/MM/YYYY - HH:mm')}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Status. do Dinheiro</label>
              <p>{pagamento.mercadopago.money_release_status}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Tipo de Operação</label>
              <p>{pagamento.mercadopago.operation_type}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Exec. de Encargos</label>
              <p>{moment(pagamento.mercadopago.charges_execution_info.internal_execution.date).format('DD/MM/YYYY - HH:mm')}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>ID da Ordem</label>
              <p>{pagamento.mercadopago.order.id}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>ID Pagador</label>
              <p>{pagamento.mercadopago.payer.id}</p>
            </div>
          </div>
          <div className="card-body row">
            <div className="col-12 col-lg-12 mb-2">
              <h5>Ponto de Interação</h5>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label> Nome do Aplicativo</label>
              <p>{pagamento.mercadopago.point_of_interaction.application_data?.name}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Versão do Aplicativo</label>
              <p>{pagamento.mercadopago.point_of_interaction.application_data?.version}</p>
            </div>
          </div>
          <div className="card-body row">
            <div className="col-12 col-lg-12 mb-2">
              <h5>Informações do Negócio</h5>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Branch</label>
              <p>{pagamento.mercadopago.point_of_interaction.business_info?.branch}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Sub_unit</label>
              <p>{pagamento.mercadopago.point_of_interaction.business_info?.sub_unit}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Unit</label>
              <p>{pagamento.mercadopago.point_of_interaction.business_info?.unit}</p>
            </div>
          </div>
          <div className="card-body row">
            <div className="col-12 col-lg-12 mb-2">
              <h5>Informações do Device</h5>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Initiation Mode</label>
              <p>{pagamento.mercadopago.point_of_interaction.device?.initiation_mode}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Manufacturer</label>
              <p>{pagamento.mercadopago.point_of_interaction.device?.manufacturer}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Model</label>
              <p>{pagamento.mercadopago.point_of_interaction.device?.model}</p>
            </div>
            <div className="col-3 col-lg-3 mb-2">
              <label>Serial Number</label>
              <p>{pagamento.mercadopago.point_of_interaction.device?.serial_number}</p>
            </div>
          </div>
          <div className="card-body row">
            <div className="col-12 col-lg-12 mb-2">
              <h5>Dados Encaminhados</h5>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Concept</label>
              <p>{pagamento.mercadopago.point_of_interaction.forward_data?.concept}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Destination User ID</label>
              <p>{pagamento.mercadopago.point_of_interaction.forward_data?.destination_user_id}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Input Type</label>
              <p>{pagamento.mercadopago.point_of_interaction.forward_data?.input_type}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Is Payer Holder</label>
              <p>{pagamento.mercadopago.point_of_interaction.forward_data?.is_payer_holder}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Marketplace</label>
              <p>{pagamento.mercadopago.point_of_interaction.forward_data?.marketplace}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Original Payment ID</label>
              <p>{pagamento.mercadopago.point_of_interaction.forward_data?.original_payment_id}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>User Role</label>
              <p>{pagamento.mercadopago.point_of_interaction.forward_data?.user_role}</p>
            </div>
          </div>
          <div className="card-body row">
            <div className="col-12 col-lg-12 mb-2">
              <h5>Informações da Locação</h5>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Source</label>
              <p>{pagamento.mercadopago.point_of_interaction.location?.source}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>State ID</label>
              <p>{pagamento.mercadopago.point_of_interaction.location?.state_id}</p>
            </div>
          </div>
          <div className="card-body row">
            <div className="col-12 col-lg-12 mb-2">
              <h5>Dados da Transação Interna - Bank Info</h5>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Collector</label>
              <p>{pagamento.mercadopago.point_of_interaction.transaction_data?.bank_info.collector.long_name}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Account ID</label>
              <p>{pagamento.mercadopago.point_of_interaction.transaction_data?.bank_info.collector.account_id}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>ID do Pagador</label>
              <p>{pagamento.mercadopago.point_of_interaction.transaction_data?.bank_info.payer.account_id}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Banco Pagador</label>
              <p>{pagamento.mercadopago.point_of_interaction.transaction_data?.bank_info.payer.long_name}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>ID da Transferencia</label>
              <p>{pagamento.mercadopago.point_of_interaction.transaction_data?.bank_transfer_id}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>ID da Transação</label>
              <p>{pagamento.mercadopago.point_of_interaction.transaction_data?.transaction_id}</p>
            </div>
          </div>
          <div className="card-body row">
            <div className="col-12 col-lg-12 mb-2">
              <h5>Outras Informações</h5>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Pos ID</label>
              <p>{pagamento.mercadopago.pos_id}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label> Processing Mode</label>
              <p>{pagamento.mercadopago.processing_mode}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Status</label>
              <p>{pagamento.mercadopago.status}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Status Detail</label>
              <p>{pagamento.mercadopago.status_detail}</p>
            </div>
            <div className="col-3 col-lg-1 mb-2">
              <label>Store ID</label>
              <p>{pagamento.mercadopago.store_id}</p>
            </div>
          </div>
        </div>
        : null
      }

      <ToastContainer position="top-right" autoClose={5000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </div>
  );
}
